<template>
  <manifest-data-table />
</template>
<script>
import ManifestDataTable from "@/components/ManifestDataTable";

export default {
  name: "Manifest",
  components: {
    ManifestDataTable
  }
};
</script>
